(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[168],{

/***/ 6513:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conference-hall",
      function () {
        return __webpack_require__(6711);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AboutGallery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_pages_Aboutus_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(641);
/* harmony import */ var _styles_pages_Aboutus_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_Aboutus_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6066);
/* harmony import */ var _Gallerymodal_Gallerymodal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1556);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);







function AboutGallery(param) {
    let { galleryImages , galleryHeading  } = param;
    const [clickedImage, setClickedImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [currentIndex, setCurrentIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const gallery_slider = {
        dots: false,
        infinite: false,
        arrows: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const handleClick = (item, index)=>{
        setCurrentIndex(index);
        setClickedImage(item.bgImage);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_pages_Aboutus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().our_gallery),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "common_title",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-center",
                            children: galleryHeading
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_pages_Aboutus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().gallery_main),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                ...gallery_slider,
                                className: "single_room_slider",
                                children: galleryImages.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pages_Aboutus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().gallery_child),
                                        onClick: ()=>handleClick(item, index),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                            src: item.bgImage,
                                            fill: true,
                                            alt: item.altTest,
                                            onClick: ()=>handleClick(item, index)
                                        })
                                    }, index))
                            }),
                            clickedImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Gallerymodal_Gallerymodal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                galleryImages: galleryImages,
                                currentIndex: currentIndex,
                                setClickedImage: setClickedImage
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 3945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WeddingPageForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Contactusform_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5475);
/* harmony import */ var _Contactusform_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Contactusform_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9198);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_datepicker__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5828);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2__);



// import sendDiningForm from "../../../lib/sendDiningForm";
// import useDiningForm from "../../../hooks/useDiningForm";


function WeddingPageForm(param) {
    let { formId , formClass  } = param;
    const [selectDate, setSelectDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(new Date());
    const [selectedOption, setSelectedOption] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [form, setForm] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        state: "",
        message: ""
    });
    const [weddingFormData, setWeddingFormData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        fullname: "",
        email: "",
        phoneno: "",
        message: ""
    });
    const handleDataChange = (e)=>{
        const { name , value  } = e.target;
        setWeddingFormData((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    const handleOptionChange = (event)=>{
        setSelectedOption(event.target.value);
    };
    const datenmonth = new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric"
    });
    const handleDateChange = (date)=>{
        setSelectDate(date);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setForm({
            state: "loading"
        });
        try {
            const dataToSend = {
                ...weddingFormData,
                date: selectDate,
                selectedOption: selectedOption
            };
            const res = await fetch("/api/send-wedding-form", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(dataToSend)
            });
            if (!res.ok) {
                throw new Error("Network response was not ok");
            }
            const result = await res.json();
            setForm({
                state: "success",
                message: result.success || "Thank you! Your message has been delivered."
            });
        // Reset form data
        // setWeddingFormData({
        //     fullname: '',
        //     email: '',
        //     phoneno: '',
        //     message: '',
        // });
        // setSelectedOption('');
        } catch (error) {
            console.error("Error:", error);
            setForm({
                state: "error",
                message: error.message || "Something went wrong"
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "".concat((_Contactusform_module_scss__WEBPACK_IMPORTED_MODULE_3___default().form), " common_padding "),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "row justify-content-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-center",
                            children: "Book your Special Day"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-md-7 col-sm-12 contact_form",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                            className: "row ".concat(formClass ? formClass : ""),
                            onSubmit: handleSubmit,
                            id: formId,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_Contactusform_module_scss__WEBPACK_IMPORTED_MODULE_3___default().form_group), " col-md-6 col-sm-12"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        id: "fullname",
                                        type: "text",
                                        name: "fullname",
                                        onChange: handleDataChange,
                                        value: weddingFormData.fullname,
                                        className: "form-control",
                                        placeholder: "Full Name",
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_Contactusform_module_scss__WEBPACK_IMPORTED_MODULE_3___default().form_group), " col-md-6 col-sm-12"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        id: "email",
                                        name: "email",
                                        type: "email",
                                        onChange: handleDataChange,
                                        value: weddingFormData.email,
                                        className: "form-control",
                                        placeholder: "Your Email",
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_Contactusform_module_scss__WEBPACK_IMPORTED_MODULE_3___default().form_group), " col-md-6"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        id: "phoneno",
                                        required: true,
                                        name: "phoneno",
                                        type: "number",
                                        onChange: handleDataChange,
                                        value: weddingFormData.phoneno,
                                        className: "form-control",
                                        placeholder: "Phone Number"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_Contactusform_module_scss__WEBPACK_IMPORTED_MODULE_3___default().form_group), " col-md-6"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                        value: selectedOption,
                                        onChange: (e)=>setSelectedOption(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                value: "",
                                                children: "No. Of Attendees"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                value: "150-200",
                                                children: "50-200"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                value: "200-250",
                                                children: "200-500"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                value: "250-300",
                                                children: "500+"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_Contactusform_module_scss__WEBPACK_IMPORTED_MODULE_3___default().form_group), " col-md-12"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_datepicker__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        wrapperClassName: "diningform-date-picker",
                                        minDate: new Date(),
                                        className: (_Contactusform_module_scss__WEBPACK_IMPORTED_MODULE_3___default().form_control),
                                        selected: selectDate,
                                        onChange: handleDateChange,
                                        placeholderText: "Please select a date"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_Contactusform_module_scss__WEBPACK_IMPORTED_MODULE_3___default().form_group), " col-md-12"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                                        id: "message",
                                        name: "message",
                                        onChange: handleDataChange,
                                        value: weddingFormData.message,
                                        className: "form-control",
                                        placeholder: "Message",
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        width: "auto"
                                    },
                                    type: "submit",
                                    className: "common_btn",
                                    children: "SEND REQUEST"
                                }),
                                form.state === "loading" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: "Sending...."
                                }) : form.state === "error" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "form_message error",
                                    children: form.message
                                }) : form.state === "success" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "form_message success",
                                    children: form.message
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 4264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const FAQs = (props)=>{
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const contentRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    const faqs = props === null || props === void 0 ? void 0 : props.faqsData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        contentRefs.current = contentRefs.current.slice(0, faqs.length);
    }, [
        faqs
    ]);
    const toggleAccordion = (index)=>{
        setOpenIndex(openIndex === index ? null : index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "destination_faqs row justify-content-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "col-12 col-sm-12 col-md-8 col-lg-8",
            children: faqs.map((item, index)=>{
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "accordion",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "accordion__title",
                            onClick: ()=>toggleAccordion(index),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                                    children: [
                                        " ",
                                        item.accordionQuestion
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "accordion_btn",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "arrow_btn ".concat(openIndex === index ? "rotate" : ""),
                                        "aria-label": "Accordion Button",
                                        children: openIndex === index ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "20px",
                                            viewBox: "0 -960 960 960",
                                            width: "20px",
                                            fill: "#000000",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M232-444v-72h496v72H232Z"
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "24px",
                                            viewBox: "0 -960 960 960",
                                            width: "20px",
                                            fill: "#000000",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: (el)=>contentRefs.current[index] = el,
                            className: "accordion__content ".concat(openIndex === index ? "accordion__content--open" : ""),
                            style: openIndex === index ? {
                                maxHeight: contentRefs.current[index] ? contentRefs.current[index].scrollHeight : "none"
                            } : {
                                maxHeight: 0
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: item.accordionAnswer
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(FAQs));


/***/ }),

/***/ 6711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Meeting; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1027);
/* harmony import */ var _styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6066);
/* harmony import */ var _components_Restaurantgallery_Restaurantgallery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8368);
/* harmony import */ var _components_Contactusform_DiningPageForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(967);
/* harmony import */ var _components_Accordion_Accordion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(678);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7294);
/* harmony import */ var _components_AboutGallery_AboutGallery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7648);
/* harmony import */ var _components_Faqs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4264);
/* harmony import */ var _components_Contactusform_WeddingPageForm__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3945);













function Meeting() {
    const galleryImages = [
        {
            bgImage: "/images/events/meeting-gallery/meeting-img1.jpg",
            altTest: "Meeting image 1"
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img2.jpg",
            altTest: "Meeting image 2"
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img3.jpg",
            altTest: "Meeting image 3"
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img4.jpg",
            altTest: "Meeting image 4"
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img5.jpg",
            altTest: "Meeting image 5"
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img6.jpg",
            altTest: "Meeting image 6"
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img7.jpg",
            altTest: "Meeting image 7"
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img8.jpg",
            altTest: "Meeting image 8"
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img9.jpg",
            altTest: "Meeting image 9"
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img10.jpg",
            altTest: "Meeting image 10"
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img11.jpg",
            altTest: "Meeting image 11"
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img12.jpg",
            altTest: "Meeting image 12"
        }
    ];
    const amenities = [
        {
            title: "Stage & Podium",
            description: "Sleek and modern podiums designed to enhance presentations and speeches.",
            hyperLink: "/",
            icon: "/icons/events/podium.svg"
        },
        {
            title: "Stationary Amenities",
            description: "Premium stationary including notepads and pens to boost productivity.",
            hyperLink: "/",
            icon: "/icons/events/stationary.svg"
        },
        {
            title: "Accommodation",
            description: "Luxurious rooms and suites provide a comfortable and memorable stay for guests.",
            hyperLink: "/",
            icon: "/icons/events/accomodation.svg"
        },
        {
            title: "Ample Parking",
            description: "Convenient and spacious parking facilities for all attendees.",
            hyperLink: "/",
            icon: "/icons/events/parking.svg"
        },
        {
            title: "Catering",
            description: "Delicious gourmet cuisine crafted to impress and delight every guest.",
            hyperLink: "/",
            icon: "/icons/events/catering.svg"
        },
        {
            title: "Entertainment",
            description: "Interactive games and engaging activities for all guests to enjoy.",
            hyperLink: "/",
            icon: "/icons/events/entertainment.svg"
        },
        {
            title: "Venue",
            description: "Stunning locations with breathtaking views, perfect for your special celebration.",
            hyperLink: "/",
            icon: "/icons/events/venue.svg"
        },
        {
            title: "Video & Photography",
            description: "Capture precious moments with professional videography and photography services.",
            hyperLink: "/",
            icon: "/icons/events/photography.svg"
        }
    ];
    const faqsData = [
        {
            id: 1,
            accordionQuestion: "Can the event venue in Shimla accommodate both small and large business events?",
            accordionAnswer: "Absolutely, our event venue in Shimla can host both small intimate gatherings and large-scale business events with ease."
        },
        {
            id: 2,
            accordionQuestion: "Is The Twin Towers Hotel considered the best event venue in Himachal Pradesh?",
            accordionAnswer: "Yes, The Twin Towers Hotel is renowned as the best event venue in Himachal Pradesh, known for its exceptional service and breathtaking views."
        },
        {
            id: 3,
            accordionQuestion: "Can The Hotel Twin Tower cater to adventure activities for event attendees?",
            accordionAnswer: "Yes, we offer outdoor adventure activities like Go-Karting, Bunjee Jumping, zip-lining, Frisbee, and much more to make your event memorable."
        },
        {
            id: 4,
            accordionQuestion: "What amenities are included in your event venue in Shimla for business events?",
            accordionAnswer: "Our event venue in Shimla includes high-speed internet, audio-visual equipment, and comfortable seating arrangements ideal for business events."
        },
        {
            id: 5,
            accordionQuestion: "Can your event venue in Shimla accommodate both corporate events and social gatherings?            ",
            accordionAnswer: "Certainly, our versatile event venue in Shimla is perfect for both corporate events and social gatherings, ensuring a successful and memorable occasion."
        }
    ];
    const scrollToSection = (redirectedSection)=>{
        const section = document.getElementById(redirectedSection);
        if (section) {
            section.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
    const handleScrollClick = (section)=>{
        return ()=>scrollToSection(section);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Conference hall Meetings | Hotel Event Spaces | The Twin Towers Hotel in Kufri, Shimla"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Experience luxury and sophistication at The Twin Towers Hotel conference hall. Book now and make your next event unforgettable."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.hoteltwintowers.com/conference-hall"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "Hotels In Shimla Best Hotels In Kufri conference hall meeting hall event space event venues corporate events birthday events"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().wedding_meeting_banner),
                    style: {
                        backgroundImage: "url(/images/events/meeting-page-banner.png)"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().banner_text),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().banner_btn),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/icons/down-arrow.svg",
                                    height: 40,
                                    width: 40,
                                    alt: "Down Icon",
                                    onClick: handleScrollClick("homeSection")
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: (_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().best_venue_sec),
                id: "homeSection",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().best_venue_sec_main), " common_title"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                children: "Premier Event Venue in Shimla"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "At The Twin Towers Hotel, we understand the importance of creating the right impression. Our venue, the best event venue in Shimla, is perfect for corporate events, business meetings, convocations, and felicitation ceremonies. Equipped with state-of-the-art technology, our spaces ensure seamless presentations and gatherings. Located in Kufri, Himachal Pradesh, our modern and elegant design provides the ideal backdrop for any event, making every occasion special and impactful."
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().restaurant), " common_padding"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().restaurant_top), " row"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().res_top_left), " col-md-6 col-sm-12 common_title"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().center_div), " col-md-10"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: "Exceptional Venue For Remarkable Events"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "Our range of event halls can accommodate gatherings of all sizes and styles. From intimate business meetings to large-scale celebrations, our versatile spaces can be tailored to your specific needs. We offer a perfect blend of elegance and functionality, ensuring that your events are memorable and seamless. Trust us to provide the ideal setting for your special moments."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "#book_your_event",
                                                className: "common_btn m-0",
                                                children: "Enquire Now"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().res_top_right), " col-md-6 col-sm-12"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/images/events/meeting-img2.png",
                                        alt: "Restaurant Image"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().restaurant_top_two), " row"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().res_top_left_two), " col-md-6 col-sm-12"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/images/events/meeting-img1.png",
                                        alt: "Restaurant Image"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().res_top_right_two), " col-md-6 col-sm-12 common_title justify-content-end"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().center_div), " col-md-10"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: "Expert Planning For Flawless Execution"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "At The Twin Towers Hotel, we transform ideas into extraordinary events. Our team excels in planning and executing flawless celebrations, ensuring every detail is perfect. From corporate gatherings to personal milestones, our expertise and attention to detail make each event memorable. Elevate your event experience with our sophisticated spaces, impeccable service, and innovative approach. Let us bring your vision to life and create unforgettable moments for you and your guests."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "#book_your_event",
                                                className: "common_btn m-0",
                                                children: "Enquire Now"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().wedding_amenities)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "common_title",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-center",
                                children: "Services We Provide"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().amenities_main), " row"),
                                children: amenities.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-sm-6 col-lg-3 col-md-6",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default().amenities),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    src: item.icon,
                                                    width: 50,
                                                    height: 50,
                                                    className: (_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_12___default()),
                                                    alt: "Highlights icon"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-center",
                                                    children: item.description
                                                })
                                            ]
                                        })
                                    }, index))
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "common_padding",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AboutGallery_AboutGallery__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    galleryImages: galleryImages,
                    galleryHeading: "Successful Events"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                style: {
                    backgroundColor: "#F5F5F5",
                    paddingBottom: "0"
                },
                id: "book_your_event",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Contactusform_WeddingPageForm__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        formId: "conferenceBookingForm",
                        formClass: "event-booking-form"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "common_padding",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "hotel_page_hotel_haeding mb-2 text-center",
                            children: "FAQs"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Faqs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            faqsData: faqsData
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 5475:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contact_from":"Contactusform_contact_from__nv1t5","form_control":"Contactusform_form_control__yk_xZ","enquire_textarea":"Contactusform_enquire_textarea__cw5RV","from_textarea":"Contactusform_from_textarea__7tv7O","submit_btn":"Contactusform_submit_btn__2H_yX","enquire_submit_btn":"Contactusform_enquire_submit_btn__3K5N4","form":"Contactusform_form__e9U20","form_group":"Contactusform_form_group__57C5b"};

/***/ }),

/***/ 641:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"aboutus":"Aboutus_aboutus__G5WWd","about_top":"Aboutus_about_top__AEnSy","about_img_sec":"Aboutus_about_img_sec__tLcO6","about_bottom":"Aboutus_about_bottom__YOxDA","amenities_main":"Aboutus_amenities_main__494qc","amenities":"Aboutus_amenities__ZZ1f5","our_gallery":"Aboutus_our_gallery__y7vcO","gallery_main":"Aboutus_gallery_main__NGTxP","gallery_child":"Aboutus_gallery_child__1tp2s"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [66,661,960,115,774,888,179], function() { return __webpack_exec__(6513); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);